import React, { Component } from 'react';
import VideoFace from './VideoFace';

class GreenScreenSystem extends Component {
	constructor(props) {
		super(props);
		this.id = props.id;
		//
		// this.scene = this.props.scene || this.props.sceneRef.current;
		// this.srcs = this.props.srcs;
		// this.similarity = this.props.similarity;
		// this.smoothness = this.props.smoothness;
		// this.spill = this.props.spill;
		// this.keyColor = this.props.keyColor;
		// this.autoPlay = true;
		// this.loop = props.loop ?? true;
		// if (props.autoPlay !== undefined) {
		// 	this.autoPlay = props.autoPlay;
		// }
	}

	render() {
		return (
			<>
				{this.props.srcs.map((src, i) => {
					const faceName = Object.keys(src)[0];
					const srcVal = src[faceName];
					if (srcVal) {
						return (
							<VideoFace
								loop={this.props.loop}
								src={srcVal}
								faceName={faceName}
								autoPlay={this.props.autoPlay}
								scene={this.props.scene}
								keyColor={this.props.keyColor}
								similarity={this.props.similarity}
								smoothness={this.props.smoothness}
								spill={this.props.spill}
							/>
						);
					} else {
						return <></>;
					}
				})}
			</>
		);
	}
}

export default GreenScreenSystem;
